var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFtx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 16,
    viewBox: "0 0 175 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.104 20.438v7.398H102.1v7.35H87.104v11.532h-9.61V13.085h26.644v7.353H87.103z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.065 20.63H107.63v-7.545h30.43v7.546h-10.386v26.088h-9.61V20.63z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.586 46.718 156.55 36.29l-6.94 10.428h-10.97l12.377-17.009-11.842-16.625h10.822l6.795 9.707 6.697-9.707h10.385l-11.842 16.24 12.618 17.393h-11.064",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.837 54h14.498V39.652H17.837V54z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.198 19.819H17.836V34.17H50.174V19.824h-4.976v-.005",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.837 0v14.348h44.91V0h-44.91",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 34.172h14.493V19.819H0V34.17z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFtx);
export default __webpack_public_path__ + "static/media/ftx.5aad4ddd61cc183d997030e650704f37.svg";
export { ForwardRef as ReactComponent };